import React from 'react';
import { PdfCanvasPlaceholder, PdfFramePlaceholder } from '../Shared/Pdf/PdfPlaceholders.tsx';

/**
 * What stands in for the card game preview while its chunk loads: the same markup
 * CardGamePreview renders on its first frame, minus the PDF (ADR 0067), so the chunk arriving
 * moves nothing under it. CardGamePreview is the other copy of this shape; change both.
 */
export function CardGamePreviewPlaceholder({
    canPreview,
    buildingLabel,
}: {
    canPreview: boolean;
    buildingLabel: string;
}) {
    if (!canPreview) {
        return (
            <div className="pdfActions">
                <PdfCanvasPlaceholder />
                <span className="pdfActionButton" aria-disabled="true">
                    {buildingLabel}
                </span>
            </div>
        );
    }
    return (
        <div className="pdfViewerContainer" role="status" aria-label={buildingLabel}>
            <PdfFramePlaceholder frameClassName="pdfViewerFrame" />
        </div>
    );
}

export default CardGamePreviewPlaceholder;
